import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "tabTrigger"];

  connect() {
    const tagName = this.tabTriggerTargets[0].getAttribute("id");
    this.switchTo(tagName);
  }

  showTab(e) {
    e.preventDefault();
    const tagName = e.target.getAttribute("id");
    this.switchTo(tagName);
  }

  switchTo(tagName) {
    const tabs = this.tabTargets;
    const tabTriggers = this.tabTriggerTargets;

    tabs.forEach((t) => {
      if (t.dataset.target === tagName) {
        t.classList.remove("hidden");
      } else {
        t.classList.add("hidden");
      }
    });

    const currentTabTrigger = tabTriggers.forEach((t) => {
      if (t.getAttribute("id") === tagName) {
        t.classList.add("!text-default-600");
      } else {
        t.classList.remove("!text-default-600");
      }
    });
  }
}
